// biome-ignore lint/suspicious/noDeprecatedImports: only render()'s 3rd `replaceNode` parameter is deprecated.
import { render } from "preact";
import { App } from "./App.tsx";
import { markBarLabels } from "./lib/barLabels.ts";
import { ignore } from "./lib/ignore.ts";
import { greetShell } from "./lib/native.ts";
import { serveShell } from "./lib/nativeApi.ts";
import { keepZoomOnFocus, markPlatform } from "./lib/platform.ts";
import { listen } from "./lib/router.ts";
import { registerServiceWorker } from "./lib/serviceWorker.ts";
import { applyPrefs, boot, followConnection } from "./lib/state.ts";

markPlatform();
markBarLabels();
greetShell();
keepZoomOnFocus();
applyPrefs(null);
listen();
boot().catch(ignore);
followConnection();
registerServiceWorker();
serveShell();
const root = document.getElementById("app");
if (root) {
  render(<App />, root);
}
